module.exports = __webpack_public_path__ + "img/swiper-1.0d76974e.png";